export default __webpack_public_path__ + "static/marryhill-98ff03bb40f3c1bf9418f877f0ee7a9a.png";